"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { BrandMark } from "@/components/brand-mark";

export function NativeAuthBrand() {
  const t = useTranslations("Common");

  return (
    <Link
      href="/"
      className="mb-8 hidden cursor-pointer flex-col items-center gap-2.5 no-underline native-app:flex"
    >
      <span aria-hidden="true">
        <BrandMark size={28} priority className="h-7 w-7" />
      </span>
      <span className="text-[10px] font-medium tracking-[0.34em] text-(--mk-cream-60) uppercase">
        {t("brand")}
      </span>
    </Link>
  );
}
